export default "__VITE_ASSET__mXzYdgw0__"